<div class="container-fluid" style="display: block; height: calc(100vh - 64px); overflow-y: auto; padding: 15px;">
  <div style="display: flex; flex-direction: column;">
    <div class="space-between">
      <span>
        <span class="rm-title rm-title-3">Deals <em *ngIf="!!selectedStatusFilter">(filtered)</em> </span>
      </span>
      <span>
        <div style="display: flex; align-items: center; justify-content: end; gap: 15px;">
          <mat-form-field style="padding-top: 5px;">
            <mat-label>Deal Status Filter</mat-label>
            <mat-select [(value)]="selectedStatusFilter" (selectionChange)="applyStatusFilter($event.value)">
              <mat-option *ngFor="let status of dealStatusList" [value]="status.key">{{status.value}}</mat-option>
            </mat-select>
          </mat-form-field>

          <button mat-icon-button
                  (click)="setPageView(DealView.CARD)" 
                  [disabled]="pageView==DealView.CARD"
                  title="View as Deal Cards"
          >
            <mat-icon>view_module</mat-icon>
          </button>

          <button mat-icon-button
                  (click)="setPageView(DealView.TABLE)"
                  [disabled]="pageView==DealView.TABLE"
                  title="View Deals as Table"
          >
            <mat-icon>list</mat-icon>
          </button>
          <!--            full buttons-->
          <div class="d-none d-md-flex">
            <button
              *ngIf="util.isIssuer()"
              mat-raised-button
              color="primary"
              (click)="openDealModal()"
              [hasPermission]="util.Permission.CAN_ADD_DEALS"
            >
              <mat-icon>library_add</mat-icon>&nbsp;Add New Deal
            </button>
            <!--mandate modal-->
            <button
              *ngIf="util.isInvestor()"
              mat-raised-button
              color="primary"
              (click)="openMandateModal()"
              [hasPermission]="util.Permission.CAN_ADD_MANDATES"
            >
              <mat-icon>library_add</mat-icon>&nbsp;Add New Mandate
            </button>
          </div>
          <!--            mobile buttons-->
          <div class="d-flex d-md-none">
            <button
              *ngIf="util.isIssuer()"
              mat-icon-button
              color="primary"
              (click)="openDealModal()"
              [hasPermission]="util.Permission.CAN_ADD_DEALS"
            >
              <mat-icon>library_add</mat-icon>
            </button>
            <!--mandate modal-->
            <button
              *ngIf="util.isInvestor()"
              mat-icon-button
              color="primary"
              (click)="openMandateModal()"
              [hasPermission]="util.Permission.CAN_ADD_MANDATES"
            >
              <mat-icon>library_add</mat-icon>
            </button>
          </div>
        </div>
      </span>
    </div>
  </div>
 
  <div class="mt-3" *ngIf="pageView == DealView.TABLE">
    <table mat-table [dataSource]="dataSource"
          [multiTemplateDataRows]="true" matSort >
      <!-- Search Header -->
      <ng-container matColumnDef="table-name">
        <th colspan="5" mat-header-cell *matHeaderCellDef>
          <span style="font-size: large;">Deals</span>
        </th>
      </ng-container>
      <!-- Search Header -->
      <ng-container matColumnDef="search-header">
        <th colspan="4" mat-header-cell *matHeaderCellDef>
          <form autocomplete="off">
            <mat-form-field style="width: 100%;">
              <mat-label>Search</mat-label>
              <input type="text" matInput (keyup)="applyFilter($event)" #input/>
              <mat-icon matSuffix>search</mat-icon>
            </mat-form-field>
          </form>
        </th>
      </ng-container>
      <!-- ID Column -->
      <!-- <ng-container matColumnDef="Id">
        <th mat-header-cell *matHeaderCellDef> ID</th>
        <td mat-cell *matCellDef="let element">
          {{ element.id }}
        </td>
      </ng-container> -->
      <!-- project Column -->
      <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="projectName"> Project</th>
        <td mat-cell *matCellDef="let element" style="max-width: 200px;">
          <app-user-card [firstName]="element.projectName"
                        [displayName]="element.assetName"
                        [borderColor]="'transparent'"
                        [sideColor]="'#345'"
                        [image]="element.dealImageUrl"
                        [imageShape]="'square'"
          ></app-user-card>
        </td>
      </ng-container>
      <!-- Business Unit Column -->
      <ng-container matColumnDef="businessUnit">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="businessUnit.displayName"
            sortActionDescription="Sort by Business Unit"> Business Unit
        </th>
        <td mat-cell *matCellDef="let element" style="padding: 5px;">
          <app-user-card [firstName]="element.businessUnit?.displayName"
                        [displayName]="element.businessUnit?.slug"
                        [borderColor]="'transparent'"
                        [sideColor]="'#ff0000'"
                        [image]="element.businessUnit?.imageUrl"
                        (click)="util.isAdmin()? util.viewBusinessUnit(element.businessUnit?.id, 'deals') : null"
                        [ngStyle]="{'cursor': util.isAdmin()? 'pointer':''}"
                        [highlightOnHover]="util.isAdmin()"
          ></app-user-card>
        </td>
      </ng-container>
      <!-- Deal Size Column -->
      <ng-container matColumnDef="dealSize">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="fundraiseSize"
            sortActionDescription="Sort by Deal Size"> Deal Size
        </th>
        <td mat-cell *matCellDef="let element"> {{ '$' + element.fundraiseSize + 'M USD' }}
        </td>
      </ng-container>
      <!-- SEC Type Column -->
      <ng-container matColumnDef="secType">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="secDealType"> Offering Type</th>
        <td mat-cell *matCellDef="let element"> {{ element.secDealType }}
        </td>
      </ng-container>
      <!-- status Column -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="dealWorkflow"
            sortActionDescription="Sort by Status"> Status
        </th>
        <td mat-cell *matCellDef="let element">
          <span [appStatus]="element.dealWorkflow">{{ element.dealWorkflow }}</span>
        </td>
      </ng-container>
      <!-- DESCRIPTION Column -->
      <ng-container matColumnDef="desc">
        <th mat-header-cell *matHeaderCellDef> Post NDA Description</th>
        <td mat-cell *matCellDef="let element" style="word-wrap: break-word;max-width: 150px;">
          <span style="font-weight: lighter;" [innerHTML]="element.description"></span>
        </td>
      </ng-container>
      <!-- Close Date Column -->
      <ng-container matColumnDef="closeDate">
        <th mat-header-cell *matHeaderCellDef
            mat-sort-header="closeDate" sortActionDescription="Sort by Close Date"> Close Date
        </th>
        <td mat-cell *matCellDef="let element"> {{ element.closeDate | date }}</td>
      </ng-container>
      <!-- created Column -->
      <ng-container matColumnDef="created">
        <th mat-header-cell *matHeaderCellDef
            mat-sort-header="created" sortActionDescription="Sort by Created"> Created
        </th>
        <td mat-cell *matCellDef="let element"> 
          <div class="date-stacked">
            <span>{{ element.created | date : 'mediumDate' }}</span>
            <span>{{ element.created | date : 'shortTime' }}</span>
          </div>
        </td>
      </ng-container>
      <!-- CLOSE Column -->
      <ng-container matColumnDef="closeType">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="dealCloseType"> Close Type</th>
        <td mat-cell *matCellDef="let element"> {{ element.dealCloseType }}</td>
      </ng-container>

      <!-- EDIT Column -->
      <ng-container matColumnDef="edit">
        <th mat-header-cell *matHeaderCellDef> Actions</th>
        <td mat-cell *matCellDef="let element">
          <div style="display: flex;">
            <button mat-icon-button
                    *ngIf="util.isAdmin()"
                    (click)="viewHistory(element)"
                    [hasPermission]="util.Permission.CAN_ACCESS_AUDITS"
            >
              <mat-icon>history</mat-icon>
            </button>
            <button mat-icon-button (click)="viewDeal(element)" title="View Deal">
              <mat-icon>east</mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="['table-name','search-header'];"></tr>
      <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky:true;"></tr>
      <tr mat-row *matRowDef="let element; columns: columnsToDisplay;">
      </tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="4">No data matching the filter.</td>
      </tr>
    </table>
  </div>

  <div class="mt-3" *ngIf="pageView == DealView.CARD">
    <!-- ADMIN Display  -->
    <div *ngIf="util.isAdmin()" style="display: block;">
      <!-- <h1>Your Rondeivu Selected Deals</h1> -->
      <div class="deals-list">
        <ng-container *ngFor="let deal of dataSource.filteredData">
          <app-dealcard [deal]="deal" [userIsLoggedIn]="true"></app-dealcard>
        </ng-container>
      </div>
    </div> 
    
    <!-- ISSUER Display  -->
    <div *ngIf="util.isIssuer()">
      <div class="deal-section" *ngIf="(dataSource.filteredData | dealStatusFilter: 'pending').length">
        <h1>Deals Pending Rondeivu Review</h1>
        <div class="deals-list">
          <ng-container *ngFor="let deal of dataSource.filteredData | dealStatusFilter: 'pending'">
            <app-dealcard  [deal]="deal" [userIsLoggedIn]="true"></app-dealcard>
          </ng-container>
        </div>
      </div>

      <div class="deal-section" *ngIf="(dataSource.filteredData | dealStatusFilter: 'onboarding').length">
        <h1>Deals Being Onboarded</h1>
        <div class="deals-list">
          <ng-container *ngFor="let deal of dataSource.filteredData | dealStatusFilter: 'onboarding'">
            <app-dealcard  [deal]="deal" [userIsLoggedIn]="true"></app-dealcard>
          </ng-container>
        </div>
      </div>

      <div class="deal-section">
        <h1>Live Deals <mat-icon title="Your live deals on Rondeivu">info</mat-icon></h1>
        <div class="deals-list" *ngIf="(dataSource.filteredData | dealStatusFilter: 'live').length; else noLiveResults">
          <ng-container *ngFor="let deal of dataSource.filteredData | dealStatusFilter: 'live'">
            <app-dealcard  [deal]="deal" [userIsLoggedIn]="true"></app-dealcard>
          </ng-container>
        </div>
        <ng-template #noLiveResults>
          <p><em>You have no live deals. Please submit a new deal for review.</em></p>
          <br />
        </ng-template>
      </div>

      <div class="deal-section" *ngIf="(dataSource.filteredData | dealStatusFilter: 'closed').length">
        <h1>Closed Deals</h1>
        <div class="deals-list">
          <ng-container *ngFor="let deal of dataSource.filteredData | dealStatusFilter: 'closed'">
            <app-dealcard [deal]="deal" [userIsLoggedIn]="true"></app-dealcard>
          </ng-container>
        </div>
      </div>
    </div> 

     <div class="deal-section" *ngIf="(dataSource.filteredData | dealStatusFilter: 'declined').length">
      <h1>Deals Declined by Rondeivu</h1>
      <div class="deals-list">
        <ng-container *ngFor="let deal of dataSource.filteredData | dealStatusFilter: 'declined'">
          <app-dealcard  [deal]="deal" [userIsLoggedIn]="true"></app-dealcard>
        </ng-container>
      </div>
    </div>

    <!-- INVESTOR Display  -->
    <div *ngIf="util.isInvestor()">
      <div class="deal-section" *ngIf="(dataSource.filteredData | dealStatusFilter: 'live').length">
        <h1>Matched Deals<mat-icon title="Deals you've been matched to based on your mandate(s) on Rondeivu.">info</mat-icon></h1>
        <div class="deals-list">
          <ng-container *ngFor="let deal of dataSource.filteredData | dealStatusFilter: 'live'">
            <app-dealcard [deal]="deal" [userIsLoggedIn]="true"></app-dealcard>
          </ng-container>
        </div>
      </div>

      <div class="deal-section" *ngIf="liveDealsPreviewList.length">
        <h1>Live Deals on Rondeivu<mat-icon title="Deals that fall outside your current mandate(s) on Rondeivu but may still be of interest.">info</mat-icon></h1>
        <div class="deals-list">
          <ng-container *ngFor="let deal of liveDealsPreviewList">
            <app-dealcard [isPreview]="true" [deal]="deal" [userIsLoggedIn]="true"></app-dealcard>
          </ng-container>
        </div>
      </div>

      <div class="deal-section" *ngIf="(dataSource.filteredData | dealStatusFilter: 'closed').length">
        <h1>Closed Deals</h1>
        <div class="deals-list">
          <ng-container *ngFor="let deal of dataSource.filteredData | dealStatusFilter: 'closed'">
            <app-dealcard  [deal]="deal" [userIsLoggedIn]="true"></app-dealcard>
          </ng-container>
        </div>
      </div>

    </div> 
  </div>

  <div class="mt-5"></div>
</div>
